import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import type { FC } from "react";
import { ToolbarIconButton } from "../../toolbar/toolbar-icon-button";

export const InsertColumnButtons: FC<{ handleInsertColumn: (insertAfter: boolean) => void }> = ({
  handleInsertColumn,
}) => {
  const [editor] = useLexicalComposerContext();

  return (
    <>
      <ToolbarIconButton
        data-analytics-id="lexical-table-menu-insert-left"
        disabled={!editor._editable}
        label={"Insert column left"}
        icon={<KeyboardArrowLeft fontSize="small" />}
        data-testid="table-menu-insert-left"
        aria-label="insert-column-left"
        onClick={() => handleInsertColumn(false)}
      />
      <ToolbarIconButton
        data-analytics-id="lexical-table-menu-insert-right"
        disabled={!editor._editable}
        label={"Insert column right"}
        icon={<KeyboardArrowRight fontSize="small" />}
        data-testid="table-menu-insert-right"
        aria-label="insert-column-right"
        onClick={() => handleInsertColumn(true)}
      />
    </>
  );
};
